import url from "./transit-12-seat-floorplan.webp";
export default { url };
